module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.community),
      expression: "community"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入小区名（查询一次仅需1钢蹦）"
    },
    domProps: {
      "value": _vm._s(_vm.community)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.community = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-remove-sign form-control-feedback"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row marketing"
  }, [_c('div', {
    staticClass: "col-lg-6 text-center"
  }, [_c('h4', [_vm._v(_vm._s(_vm.subtitleMsg))]), _vm._v(" "), _vm._l((_vm.lists), function(item) {
    return _c('div', {
      key: item,
      staticClass: "list-item"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": {
          path: '/detail',
          query: {
            cm: item
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(item) + "\n              ")])], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-1ff30334!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 186
// module chunks = 2